import React, { memo, useContext, useEffect, useState } from 'react';
import { Footer as MastheadFooter } from '@spotify-internal/masthead-react';
import DeviceContext from '../../configuration/context/device';
import EmbeddedContext from '../../configuration/context/embedded';
export function Footer(props) {
    const device = useContext(DeviceContext);
    const { isEmbedded } = useContext(EmbeddedContext);
    const [isMobile, setIsMobile] = useState(device.platform === 'ios');
    useEffect(() => {
        if (device.platform === 'ios') {
            setIsMobile(true);
        }
    }, [device]);
    return isMobile || isEmbedded ? React.createElement(React.Fragment, null) : React.createElement(MastheadFooter, Object.assign({}, props));
}
export default memo(Footer);
//# sourceMappingURL=footer.js.map